import { render } from "./LeftSidebar.vue?vue&type=template&id=519bf101&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import "./LeftSidebar.vue?vue&type=style&index=0&id=519bf101&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519bf101"]])

export default __exports__